<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->
<template>
  <v-layout class="pa-0 ma-0" ml-2 row>
    <v-container>
      <template
        v-if="
          !(
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
              .products_count === 1 &&
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
              .markets_count === 1
          )
        "
      >
        <v-row no-gutters>
          <v-col>
            <select
              @change="update_values($event)"
              class="blue white--text pa-1 pt-0 pb-0 rounded mr-1 caption mt-2"
              v-if="entry.display_unit === 'currency'"
              style="width: 75px"
            >
              <option disabled :value="multiplier_selected">Please Select</option>
              <option>Base</option>
              <option>K (000)</option>
              <option>Mn (Million)</option>
              <option>Bn (Billion)</option>
            </select>
          </v-col>
          <v-col sm="3">
            <v-tooltip left color="success">
              <template v-slot:activator="{on, attrs}">
                <span v-on="on">
                  <v-text-field
                    v-model="entry_min"
                    :type="number"
                    outlined
                    single-line
                    dense
                    :hide-details="true"
                    :hide-spin-buttons="true"
                    class="caption"
                    :disabled="
                      filters_updating_status ||
                        (entry_min === entry_max && !filters_changed)
                    "
                    @change="
                      update_state(filter_name, entry.id, [entry_min, entry_max], false)
                    "
                    @input="
                      update_state(filter_name, entry.id, [entry_min, entry_max], false)
                    "
                    :append-outer-icon="
                      entry_min === entry_max
                        ? 'mdi-code-equal'
                        : 'mdi-code-greater-than-or-equal'
                    "
                  />
                </span>
              </template>
              <span>{{ entry_min_hover_f }}</span>
            </v-tooltip>
          </v-col>
          <v-col sm="3">
            <v-tooltip top color="success">
              <template v-slot:activator="{on, attrs}">
                <v-text-field
                  v-if="entry_max !== entry_min || filters_changed"
                  v-model="entry_max"
                  :type="number"
                  outlined
                  single-line
                  :hide-details="true"
                  :hide-spin-buttons="true"
                  :disabled="filters_updating_status"
                  class="caption"
                  dense
                  v-on="on"
                  @change="
                    update_state(filter_name, entry.id, [entry_min, entry_max], false)
                  "
                  @input="
                    update_state(filter_name, entry.id, [entry_min, entry_max], false)
                  "
                  prepend-icon="mdi-code-less-than-or-equal"
                >
                </v-text-field>
              </template>
              <span>{{ entry_max_hover_f }}</span>
            </v-tooltip>
          </v-col>
          <v-col sm="3" class="ml-2 pt-1">
            <div class="d-inline-block">
              <template
                v-if="
                  (entry_min !== entry.min / multiplier ||
                    entry_max !== entry.max / multiplier) &&
                    !filters_updating_status &&
                    entry.last_selected === true
                "
              >
                <v-tooltip top max-width="100px" color="success">
                  <template v-slot:activator="{on, attrs}">
                    <v-btn
                      @click="
                        update_state(filter_name, entry.id, [entry_min, entry_max], true)
                      "
                      x-small
                      class="yellow mt-1"
                      v-on="on"
                    >
                      Update
                    </v-btn>
                  </template>
                  <span
                    >Click on [UPDATE] to refresh summary info with your latest filter
                    changes. To extract updated results for current filter changes select
                    [APPLY] at the top of this form.</span
                  >
                </v-tooltip>
              </template>
            </div>
          </v-col>
        </v-row>
      </template>
      <v-flex v-else>
        <v-tooltip top color="success">
          <template v-slot:activator="{on, attrs}">
            <div class="ml-7" v-on="on">
              {{ entry_max }}
            </div>
          </template>
          <span>{{ p1c1_hover_text_f }}</span>
        </v-tooltip>
      </v-flex>
    </v-container>
  </v-layout>
</template>

<script>
import {eventBus} from '@/main';

export default {
  name: 'dropdown_filter',
  props: {
    filter_name: String,
    entry: Object,
    multiple: Boolean,
    filters_updating_status: Boolean,
    filters_changed: Boolean,
  },
  watch: {
    entry: function() {
      this.entry_min =
        this.entry_min > this.entry.min / this.multiplier
          ? this.entry_min
          : this.entry.min / this.multiplier;
      this.entry_max =
        this.entry_max < this.entry.max / this.multiplier
          ? this.entry_max
          : this.entry.max / this.multiplier;
      this.before_update_min = this.entry.min / this.multiplier;
      this.before_update_max = this.entry.max / this.multiplier;
    },
  },
  mounted() {
    this.entry_min = this.entry.min / this.multiplier;
    this.entry_max = this.entry.max / this.multiplier;
    this.before_update_min = this.entry_min;
    this.before_update_max = this.entry_max;
  },
  computed: {
    multiplier_string_for_display() {
      //only the currency gets the multipler
      if (this.entry.name.includes('%')) {
        return '%';
      }
      if (this.entry.display_unit === 'currency') {
        return this.multiplier_selected;
      } else {
        return '';
      }
    },
    multiplier() {
      if (this.entry.name.includes('%')) {
        return 0.01;
      }
      if (this.entry.display_unit === 'currency') {
        return this.mult[this.multiplier_selected] / this.exchangeRate;
      } else {
        return 1;
      }
    },
    p1c1_hover_text_f() {
      //
      let product = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .selections.products.HS6_Code[0];
      let market = this.codeToMarket(
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code[0],
      );
      let extra_text = '';

      if (
        this.entry.name.indexOf('F1') !== -1 ||
        this.entry.name.indexOf('F3.2.1') !== -1
      ) {
        extra_text = `${market}`;
      } else if (this.entry.name.indexOf('F4') !== -1) {
        extra_text = `${product}`;
      } else {
        extra_text = `${market} and ${product}`;
      }

      if (this.entry_min === this.entry_max) {
        return `The only outcome for ${extra_text} is ${this.entry_max} ${
          this.multiplier_string_for_display
        }`;
      } else return '';
    },
    entry_min_hover_f() {
      if (this.entry_min === this.entry_max) {
        return `Based on the current selections the only outcome is ${this.entry_min} ${
          this.multiplier_string_for_display
        }`;
      } else
        return `Enter value >= ${this.before_update_min} ${
          this.multiplier_string_for_display
        }`;
    },
    entry_max_hover_f() {
      return `Enter value <= ${this.before_update_max} ${
        this.multiplier_string_for_display
      }`;
    },
  },
  data: () => ({
    mult: {
      Base: 0.001,
      'K (000)': 1,
      'Mn (Million)': 1000,
      'Bn (Billion)': 1000000,
    },
    multiplier_selected: 'Base',
    entry_min: null,
    entry_max: null,
    before_update_min: null,
    before_update_max: null,
  }),
  methods: {
    register_change() {
      eventBus.$emit('FILTER_CHANGED');
    },
    update_values(new_value) {
      let old_m = this.mult[this.multiplier_selected]; // old multiplier value
      let new_m = this.mult[new_value.target.value]; //from the click

      let conversion_factor = new_m / old_m;
      this.multiplier_selected = new_value.target.value;

      this.entry_min = this.entry_min / conversion_factor;
      this.entry_max = this.entry_max / conversion_factor;
      this.before_update_min = this.before_update_min / conversion_factor;
      this.before_update_max = this.before_update_max / conversion_factor;
    },

    update_state(filter_name, id, value, run_update_filters = true) {
      let min_val = Number(value[0]);
      let max_val = Number(value[1]);

      let do_the_run_min = false;
      let do_the_run_max = false;

      if (min_val > max_val || isNaN(min_val)) {
        this.entry_min = this.entry.min / this.multiplier;
      } else {
        do_the_run_min = true;
      }

      if (max_val < min_val || isNaN(max_val)) {
        this.entry_max = this.entry.max / this.multiplier;
      } else {
        do_the_run_max = true;
      }

      if (do_the_run_min === true && do_the_run_max === true) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });

        let value_to_set = {
          filter_name: filter_name,
          id: id,
          value: 0,
          selected_value: [min_val * this.multiplier, max_val * this.multiplier],
        };

        this.$store.commit('setFilter', value_to_set);

        // THe code below overrides the special custom query value
        // All the filters ill be moved to here later
        // Initially when a list filter is selected this is set but when you select or change that in the
        // Main filter box, this needs to be overridden as this object is injected last and will override any
        // user changes settings
        // because this is a dropdown the __lte and __gte values is set for the column name
        let col_name = this.$store.state.tradeDSM.dsm_filter_setttings.Filters[
          filter_name
        ]['entries'][id]['col_name'];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query[
          `${col_name}__gte`
        ] = min_val * this.multiplier;
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query[
          `${col_name}__lte`
        ] = max_val * this.multiplier;

        eventBus.$emit('FILTER_CHANGED');
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = true;
        if (run_update_filters === true) {
          this.update_filters_selection(true).then(() => {
            this.before_update_min = this.entry.min / this.multiplier;
            this.before_update_max = this.entry.max / this.multiplier;
          });
        }
      }
    },
  },
};
</script>
